import React from "react";
import styled from "styled-components";

import background from "../../../assets/images/heroVerify.svg";
import icon from "../../../assets/icons/errorVerify.svg";

const Container = styled.div`
  background: url(${background}) no-repeat;
  background-size: cover;
  height: 100vh;
  //overflow-y: hidden;
  padding: 200px 500px;

  @media screen and (max-width: 820px) {
    padding: 100px 20px;
  }
`;
const Card = styled.div`
  margin: auto;
  margin-top: 5%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 50px 20px;
  border: 1px solid #d0d5dd;
  border-radius: 8px;
  background-color: #fff;
  h3 {
    margin-top: 20px;
  }
  p {
    margin: 20px 0px;
  }
  .buttons {
    display: flex;
    margin-top: 20px;
    gap: 10px;
    .go-back,
    .resend {
      padding: 10px 16px;
      height: 40px;
      border: 1px solid #d0d5dd;
      border-radius: 8px;
      font-size: 14px;
      background-color: transparent;
      text-decoration: none;
      cursor: pointer;
      a {
        text-decoration: none;
        color: #344054;
      }
    }
    .resend {
      color: #fff;
      border: 1px solid #03a9f4;
      background-color: #03a9f4;
    }
  }
`;

const VerificationFailed = ({ userMail, handleResend, loading }) => {
  return (
    <Container>
      <Card>
        <img src={icon} alt="icon" />
        <h3>Email Verification Failed</h3>
        <p>Your email {userMail} was not successfully verified</p>
        <div className="buttons">
          <button className="go-back">
            <a href="/signup">Go back</a>
          </button>
          <button className="resend" onClick={handleResend} disabled={loading}>
          {loading ? 'Resending...' : 'Resend'}
          </button>
        </div>
      </Card>
    </Container>
  );
};

export default VerificationFailed;
